import { render, staticRenderFns } from "./header.vue?vue&type=template&id=1d0c0846&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0c0846')) {
      api.createRecord('1d0c0846', component.options)
    } else {
      api.reload('1d0c0846', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=1d0c0846&", function () {
      api.rerender('1d0c0846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Header/header.vue"
export default component.exports